import { render, staticRenderFns } from "./Metode.vue?vue&type=template&id=0525c4f9&"
import script from "./Metode.vue?vue&type=script&lang=js&"
export * from "./Metode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports